/**
 * The type of ad slot you define in the advertising config.
 */
export const AdvertisingSlotConfigType = {
  /**
   * Linear ads, mostly advertisements videos or even interactive content, will interrupt the content playback.
   */
  Linear: 'LINEAR',

  /**
   * Non-linear ads, mostly images, are displayed alongside the content. The content is not interrupted.
   */
  NonLinear: 'NON_LINEAR',
} as const;

/**
 * {@inheritDoc AdvertisingSlotConfigType:var}
 */
export type AdvertisingSlotConfigType = (typeof AdvertisingSlotConfigType)[keyof typeof AdvertisingSlotConfigType];
